import { Checkbox } from "components/Atoms/inputs/Checkbox";
import { PhosphorTrashButton } from "components/Atoms/PhosphorIconButton";
import React from "react";
import { getFormElementType } from "utilities/freefieldUtils";

interface Props {
  definition: server.dto.FreeFieldDefinitionSmall
  freefield: server.dto.FreeFieldForWebform
  onMandatoryToggle: (id: number) => void
  onRemove: (id: number) => void
}

export const DraggableFreefield = (props: Props) => {
  return (
    <>
      <div className="grow1">
        <div>{props.definition.title}</div>
        <div className="text-sublabel">{getFormElementType(props.definition.type).text}</div>
      </div>
      <div className="margin-right-large">
        <Checkbox
          checked={props.freefield.isMandatory}
          onChange={() => props.onMandatoryToggle(props.freefield.freeFieldDefinitionId)}
          label={RESX.GeneralWarnings.InputMandatory}
        />
      </div>
      <PhosphorTrashButton
        layout="in-square"
        onClick={() => props.onRemove(props.freefield.freeFieldDefinitionId)}
      />
    </>
  );
};
